/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var ArrowFigureASquareRightIcon24Solid = forwardRef('ArrowFigureASquareRightIcon24Solid', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 24 }, props),
        React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M6.5 2A4.5 4.5 0 0 0 2 6.5v11A4.5 4.5 0 0 0 6.5 22h11a4.5 4.5 0 0 0 4.5-4.5v-11A4.5 4.5 0 0 0 17.5 2h-11Zm6.246 5.293a1 1 0 0 0 0 1.414L15.039 11H7a1 1 0 1 0 0 2h8.039l-2.293 2.293a1 1 0 1 0 1.414 1.414l3.006-3.006c.94-.94.94-2.463 0-3.402L14.16 7.293a1 1 0 0 0-1.414 0Z" })));
});
